import apiRequest from "./apiRequest";

export const createContactDetails = async (params, token) => {
  const userDetails = await apiRequest.post(
    "v2/accounts/contact_details",
    params,
    {
      headers: {
        authorization: `Bearer ${token}`,
      },
    }
  );

  return userDetails;
};

export const updateContactDetails = async (params, token) => {
  const userDetails = await apiRequest.put(
    "v2/accounts/contact_details",
    params,
    {
      headers: {
        authorization: `Bearer ${token}`,
      },
    }
  );

  return userDetails;
};

export const getContactDetails = async (token) => {
  const userDetails = await apiRequest.get("v2/accounts/contact_details", {
    headers: {
      authorization: `Bearer ${token}`,
    },
  });

  return userDetails.data;
};

export const getProfile = async (token) => {
  const userProfile = await apiRequest.get("v2/accounts/profile", {
    headers: {
      authorization: `Bearer ${token}`,
    },
  });

  return userProfile.data.data;
};

export const deleteAccount = async (token) => {
  const userDetails = await apiRequest.delete("v2/accounts/profile", {
    headers: {
      authorization: `Bearer ${token}`,
    },
  });

  return userDetails;
};

export const updateProfile = async (params, token) => {
  const userDetails = await apiRequest.patch("v2/accounts/profile", params, {
    headers: {
      authorization: `Bearer ${token}`,
    },
  });
  return userDetails;
};

export const getStripePortal = async (token) => {
  const result = await apiRequest.get("/v2/subscriptions/portal", {
    headers: {
      authorization: `Bearer ${token}`,
    },
  });
  return result.data;
};
